import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Link } from "react-router-dom";
import HtmlContent from '@medscape-promo/medscapetv/html-content';
const PlayIcon = () => {
    return (
        <svg width="46px" height="46px" viewBox="0 0 46 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-489.000000, -116.000000)">
                    <g id="PlayIcon" transform="translate(490.000000, 117.000000)">
                        <ellipse stroke="#FFFFFF" fillOpacity="0.200000003" fill="#000000" cx="22.0507614" cy="22.1690722" rx="22.0507614" ry="22.1690722"></ellipse>
                        <polyline fill="#FFFFFF" points="19.2944162 29.6250245 19.2944162 14.437326 29.0119112 22.0305077 19.2944162 29.6250245"></polyline>
                    </g>
                </g>
            </g>
        </svg>
    )
}
class HomeTemplate extends Component {
    constructor(props) {
        super(props);
        require("./home-template.scss");
        //console.log("[HomeTemplate] props:",props);
    }
    render() {
        const { linksTarget, heroImage, specialtyTitle, summary, title, episodePath, imageServer } = this.props;
        const heroStyle = {
            backgroundImage: `linear-gradient(to right,#000 0,transparent 50%,#000 100%),url(${imageServer.host}${heroImage})`
        }


        return (
            <div className="home-template">
                <div className="hero-bg" style={heroStyle}>
                </div>
                <div className="hero-content">
                    <div className="specialty-title">{specialtyTitle}</div>
                    <h1 className="program-title" dangerouslySetInnerHTML={{__html: title} }></h1>
                    <HtmlContent className="description" content={summary} linksTarget={linksTarget} />
                    <div className="button-container">
                        <Link className="button-link" to={episodePath}>
                            <div className="container">
                                <span className="icon"><PlayIcon /></span><span className="label">Episode 1</span>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        )
    }

    static get propTypes() {
        return {
            linksTarget: PropTypes.string,
            heroImage: PropTypes.string,
            specialtyTitle: PropTypes.string,
            summary: PropTypes.string,
            title: PropTypes.string,
            episodePath: PropTypes.string,
            imageServer: PropTypes.object
        }
    }

    static get defaultProps() {
        return {
            linksTarget: "",
            heroImage: "",
            specialtyTitle: "",
            summary: "",
            title: "",
            episodePath: "",
            imageServer: {
                host: ""
            }
        }
    }
}



export default HomeTemplate;